import React, { useState, useEffect, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import "../OnlineRegister/OnlineRegister.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import axios from "../../utils/axiosConfig";
import { BASE_URL } from "../../utils/config";

const OnlineRegister = () => {

    const [captcha, setCaptcha] = useState(null);

const [leftImage,setLeftImage]=useState("");
const [admissionStatus,setAdmissionStatus]=useState("OPEN");
const [admissionMessage,setAdmissionMessage]=useState("");

const [showModal,setShowModal]=useState(false);
const [classes,setClasses]=useState([]);

const formRef=useRef();
const photoInputRef = useRef();   // ⭐ NEW

const [errors,setErrors]=useState({});
const [age,setAge]=useState("");

const defaultPreview="https://cdn-icons-png.flaticon.com/512/3135/3135715.png";

const [formData,setFormData]=useState({
yourName:"",
birthdate:"",
fatherName:"",
motherName:"",
addressComplete:"",
phoneNumber:"",
email:"",
aadhaar:"",
gender:"",
classApplyfor:"",
enterDetails:"",
uploadPhoto:null,
preview:defaultPreview,
submitDate:new Date().toISOString().split("T")[0]
});


/* ================= LOAD DATA ================= */

useEffect(()=>{

setShowModal(true);

/* LOAD CLASSES */
axios.get("/api/classes")
.then(res=>{
setClasses(res.data);
})
.catch(err=>{
console.log(err);
});

/* LOAD ADMISSION SETTINGS */
axios.get("/api/registration-setting")
.then(res=>{

if(res.data){

setLeftImage(`${BASE_URL}/uploads/${res.data.left_panel_image}`);
setAdmissionStatus(res.data.admission_status);
setAdmissionMessage(res.data.admission_message);

}

})
.catch(err=>{
console.log(err);
});

},[]);


/* ================= AGE ================= */

const calculateAge=(dob)=>{

const birth=new Date(dob);
const today=new Date();

let age=today.getFullYear()-birth.getFullYear();
const m=today.getMonth()-birth.getMonth();

if(m<0 || (m===0 && today.getDate()<birth.getDate())){
age--;
}

setAge(age);

};


/* ================= INPUT ================= */

const handleChange=(e)=>{

const {name,value,files}=e.target;

let updatedValue=value;

if(name==="uploadPhoto"){

const file=files[0];

setFormData({
...formData,
uploadPhoto:file,
preview:file?URL.createObjectURL(file):defaultPreview
});

return;
}

if(name==="birthdate"){
calculateAge(value);
}

if(["yourName","fatherName","motherName","addressComplete","aadhaar","enterDetails"].includes(name)){
updatedValue=value.toUpperCase();
}

if(name==="phoneNumber"){
updatedValue=value.replace(/\D/g,"").slice(0,10);
}

setFormData({
...formData,
[name]:updatedValue
});

setErrors({
...errors,
[name]:""
});

};


/* ================= VALIDATION ================= */

const validate=()=>{

let newErrors={};

if(!formData.yourName)newErrors.yourName="Required";
if(!formData.fatherName)newErrors.fatherName="Required";
if(!formData.motherName)newErrors.motherName="Required";
if(!formData.addressComplete)newErrors.addressComplete="Required";
if(!formData.gender)newErrors.gender="Required";
if(!formData.classApplyfor)newErrors.classApplyfor="Required";
if(!formData.birthdate)newErrors.birthdate="Required";

if(!/^[0-9]{10}$/.test(formData.phoneNumber)){
newErrors.phoneNumber="Invalid phone";
}

if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)){
newErrors.email="Invalid email";
}

setErrors(newErrors);

return Object.keys(newErrors).length===0;

};


/* ================= PDF ================= */

const downloadPDF=async()=>{

const canvas=await html2canvas(formRef.current,{
scale:2,
useCORS:true
});

const imgData=canvas.toDataURL("image/jpeg",1.0);

const pdf=new jsPDF("p","mm","a4");

const pageWidth=pdf.internal.pageSize.getWidth();
const imgWidth=pageWidth-20;
const imgHeight=(canvas.height*imgWidth)/canvas.width;

pdf.addImage(imgData,"JPEG",10,25,imgWidth,imgHeight);

pdf.save("Registration_Form.pdf");

};


/* ================= PRINT ================= */

const handlePrint=()=>window.print();


/* ================= SUBMIT ================= */

const handleSubmit=async(e)=>{

e.preventDefault();

if (!captcha) {
    alert("Please verify captcha");
    return;
}

if(!validate()) return;

try{

const form=new FormData();

form.append("yourName",formData.yourName);
form.append("birthdate",formData.birthdate);
form.append("age",age);
form.append("fatherName",formData.fatherName);
form.append("motherName",formData.motherName);
form.append("addressComplete",formData.addressComplete);
form.append("phoneNumber",formData.phoneNumber);
form.append("email",formData.email);
form.append("aadhaar",formData.aadhaar);
form.append("gender",formData.gender);
form.append("classApplyfor",formData.classApplyfor);
form.append("enterDetails",formData.enterDetails);
form.append("submitDate",formData.submitDate);

if(formData.uploadPhoto){
form.append("photo",formData.uploadPhoto);
}

form.append("captcha", captcha);

await axios.post("/api/register", form);

alert("Registration Saved Successfully");

/* ===== CLEAR FORM ===== */

setFormData({
yourName:"",
birthdate:"",
fatherName:"",
motherName:"",
addressComplete:"",
phoneNumber:"",
email:"",
aadhaar:"",
gender:"",
classApplyfor:"",
enterDetails:"",
uploadPhoto:null,
preview:defaultPreview,
submitDate:new Date().toISOString().split("T")[0]
});

setAge("");
setErrors({});

/* ⭐ CLEAR FILE INPUT */
if(photoInputRef.current){
photoInputRef.current.value="";
}

}catch(err){

console.error(err);
alert("Server error");

}

};


/* ================= RESET ================= */

const handleReset=()=>{

setFormData({
yourName:"",
birthdate:"",
fatherName:"",
motherName:"",
addressComplete:"",
phoneNumber:"",
email:"",
aadhaar:"",
gender:"",
classApplyfor:"",
enterDetails:"",
uploadPhoto:null,
preview:defaultPreview,
submitDate:new Date().toISOString().split("T")[0]
});

setAge("");
setErrors({});

if(photoInputRef.current){
photoInputRef.current.value="";
}

};


if(!showModal) return null;


/* ================= UI ================= */

return(

<div className="register-main">

<div className="register-box row" ref={formRef}>

<div
className="col-lg-4 left-panel d-none d-lg-flex"
style={{
backgroundImage:`url(${leftImage})`,
backgroundSize:"cover",
backgroundPosition:"center"
}}
></div>

<div className="col-lg-8 col-12 form-panel">

<div className="print-header">
<h5>REGISTRATION FORM</h5>
<span>Registration Date: {formData.submitDate}</span>
</div>

<h5 className="form-title">REGISTRATION FORM</h5>

{admissionStatus==="CLOSED" ? (

<div className="alert alert-danger text-center mt-4">
<h4>{admissionMessage}</h4>
Admissions are currently closed.
</div>

) : (

<form onSubmit={handleSubmit}>

<div className="row g-1">

<div className="col-md-6">
<label>Full Name *</label>
<input name="yourName" className={`form-control ${errors.yourName && "error"}`} value={formData.yourName} onChange={handleChange}/>
</div>

<div className="col-md-3">
<label>Birth Date *</label>
<input type="date" name="birthdate" value={formData.birthdate} className={`form-control ${errors.birthdate && "error"}`} onChange={handleChange}/>
</div>

<div className="col-md-3">
<label>Age</label>
<input className="form-control" value={age} readOnly/>
</div>

<div className="col-md-6">
<label>Father Name *</label>
<input name="fatherName" className={`form-control ${errors.fatherName && "error"}`} value={formData.fatherName} onChange={handleChange}/>
</div>

<div className="col-md-6">
<label>Mother Name *</label>
<input name="motherName" className={`form-control ${errors.motherName && "error"}`} value={formData.motherName} onChange={handleChange}/>
</div>

<div className="col-md-6">
<label>Phone *</label>
<input name="phoneNumber" className={`form-control ${errors.phoneNumber && "error"}`} value={formData.phoneNumber} onChange={handleChange}/>
</div>

<div className="col-md-6">
<label>Email *</label>
<input name="email" className={`form-control ${errors.email && "error"}`} value={formData.email} onChange={handleChange}/>
</div>

<div className="col-md-6">
<label>Aadhaar</label>
<input name="aadhaar" className="form-control" value={formData.aadhaar} onChange={handleChange}/>
</div>

<div className="col-md-6">
<label>Gender *</label>
<select name="gender" className={`form-select ${errors.gender && "error"}`} value={formData.gender} onChange={handleChange}>
<option value="">Select</option>
<option>Male</option>
<option>Female</option>
</select>
</div>

<div className="col-md-4">
<label>Class Applying For *</label>
<select name="classApplyfor" className={`form-select ${errors.classApplyfor && "error"}`} value={formData.classApplyfor} onChange={handleChange}>
<option value="">Select Class</option>
{classes.map(cls=>(
<option key={cls.id} value={cls.class_name}>{cls.class_name}</option>
))}
</select>
</div>

<div className="col-md-6">
<label>Upload Photo</label>
<input
type="file"
name="uploadPhoto"
className="form-control"
ref={photoInputRef}
onChange={handleChange}
/>
</div>

<div className="col-md-2 text-center">
<img src={formData.preview} className="previewimg" alt="preview"/>
</div>

<div className="col-12">
<label>Complete Address *</label>
<textarea name="addressComplete" className={`form-control ${errors.addressComplete && "error"}`} rows="1" value={formData.addressComplete} onChange={handleChange}/>
</div>

<div className="col-12">
<label>Parent / Guardian (For Accounts & Reports)</label>
<textarea name="enterDetails" className="form-control" rows="1" value={formData.enterDetails} onChange={handleChange}/>
</div>

    <div style={{ marginTop: "20px" }}>
        <ReCAPTCHA
            sitekey="6Lf7oNMsAAAAAETiWwBj-narLfqUej71jqWTPnBW"
            onChange={(value) => setCaptcha(value)}
        />
    </div>

<div className="col-12 mt-2 d-flex gap-2 flex-wrap">
<button type="submit" className="btn btn-success">Submit</button>
<button type="button" className="btn btn-primary" onClick={downloadPDF}>PDF</button>
<button type="button" className="btn btn-dark" onClick={handlePrint}>Print</button>
<button type="button" className="btn btn-secondary" onClick={handleReset}>Reset</button>
</div>

</div>

</form>

)}

</div>

</div>

</div>

);

};

export default OnlineRegister;